export default __webpack_public_path__ + "static/media/profileSectionEmpty.55eb3fd7.svg";